import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Mobile-only "Create" pill that lives in-page (frees room in the top header).
export const MobileCreateButton = ({ className = "" }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const go = () => navigate(user ? "/diy" : "/login");
  return (
    <button
      data-testid="mobile-create-btn"
      onClick={go}
      title="Create a new video"
      className={`sm:hidden shrink-0 inline-flex items-center justify-center px-4 py-2 whitespace-nowrap rounded-full bg-[#1e3aaa] hover:bg-[#16267a] text-white text-sm font-bold shadow-sm transition-colors ${className}`}
    >
      Free Create
    </button>
  );
};

export default MobileCreateButton;
